import { object, number } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  rxVendorId: number().required(),
})

export const url = ({ rxVendorId }) => `/v1/providers/${rxVendorId}/prescription-changes`
